import { memo } from 'react'
import { SVGProps } from './types/iconType'

export const ArrowDownIcon = memo(({ style, className }: SVGProps) => {
  return (
    <svg viewBox="0 0 13 9" xmlns="http://www.w3.org/2000/svg" style={style} className={className}>
      <path
        d="M7.684 7.782l4.852-4.921a1.169 1.169 0 000-1.648 1.133 1.133 0 00-1.613 0L6.872 5.32 2.82 1.213a1.133 1.133 0 00-1.614 0 1.17 1.17 0 00-.332.824 1.17 1.17 0 00.332.824l4.852 4.92a1.136 1.136 0 001.625 0z"
        fillRule="evenodd"
      />
    </svg>
  )
}
)